import { BookingSummaryReportModel } from '@/__generated';
import { formatPriceWithCurrency } from '@/hooks/useCurrencyFormat';
import { apiSdk } from '@/httpClient';
import { AppUrls } from '@/urls';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {};

export default function Next30DaysReport({}: Props) {
  const [report, setReportDetail] = React.useState<BookingSummaryReportModel>();

  React.useEffect(() => {
    apiSdk.AgentBookingReportService.getBookingSummaryReport().then(res => {
      setReportDetail(res);
    });
  }, []);
  return (
    <div className="row y-gap-10">
      <div className="col-xl-5 col-md-6">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3">
          <div className="col-12 fw-500 text-18">Automatic Booking Cancellation</div>

          <div className="row y-gap-20 justify-between align-items-start">
            <div className="col-6  text-center">
              <div className="text-26 lh-16 fw-600 mt-5">{report?.totalAutomaticCancellationWithin24Hours || 0}</div>
              <div className="fw-500 text-blue-1">
                <Link to="/agent/on-hold-bookings?autoCancelTime=24">Cancel within 24 Hours</Link>
              </div>
            </div>
            <div className="col-6 text-center">
              <div className="text-26 lh-16 fw-600 mt-5">{report?.totalAutomaticCancellationWithin48Hours || 0}</div>
              <div className="fw-500 text-blue-1">
                <Link to="/agent/on-hold-bookings?autoCancelTime=48">Cancel within 2 Days</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-7 col-md-6">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3">
          <div className="col-12 fw-500 text-18">Upcoming Booking</div>

          <div className="row y-gap-20 justify-between align-items-start">
            <div className="col-4  text-center">
              <div className="text-26 lh-16 fw-600 mt-5">{report?.upComingBookingsWithin7Days || 0}</div>
              <div className="fw-500 text-blue-1">
                <Link to="/agent/bookings?checkInWithin=7">Check-in within 7 Days</Link>
              </div>
            </div>

            <div className="col-4  text-center">
              <div className="text-26 lh-16 fw-600 mt-5">{report?.upComingBookingsWithin30Days || 0}</div>
              <div className="fw-500 text-blue-1">
                <Link to="/agent/bookings?checkInWithin=30">Check-in within 30 Days</Link>
              </div>
            </div>
            <div className="col-4  text-center">
              <div className="text-26 lh-16 fw-600 mt-5">{report?.totalInProcessBookings || 0}</div>
              <div className="fw-500 text-blue-1">
                <Link to={AppUrls.AgentTodoList}>In Process Bookings</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
